import qs from 'qs'

import { reportNavType } from '@edulastic/constants/const/report'

import API from '../utils/API'
import { prefix, paramsSerializer } from './utils'

const api = new API()

const { WHOLE_LEARNER_REPORT } = reportNavType

const getWLRPerformanceMetrics = (data) => {
  const queryString = qs.stringify(data)
  return api.callApi({
    useSlowApi: true,
    url: `${prefix}/${WHOLE_LEARNER_REPORT}?${queryString}`,
    method: 'get',
    data,
  })
}

const getWLRAttendanceMetrics = (data) => {
  const queryString = qs.stringify(data)
  return api.callApi({
    useSlowApi: true,
    url: `${prefix}/${WHOLE_LEARNER_REPORT}/attendance?${queryString}`,
    method: 'get',
    data,
  })
}

const getWLRRiskMetrics = (data) =>
  api.callApi({
    useSlowApi: true,
    url: `${prefix}/${WHOLE_LEARNER_REPORT}/risk`,
    method: 'get',
    params: data,
    paramsSerializer,
  })

export default {
  getWLRPerformanceMetrics,
  getWLRAttendanceMetrics,
  getWLRRiskMetrics,
}
